import makeStyles from '@mui/styles/makeStyles'

const useInvoiceBillStyles = makeStyles({
  root: {},
  Boldstyle: {
    fontWeight: 'bold',
  },
  rowstyle: {
    display: 'flex',
    flexDirection: 'row',
  },
  halfStyle: {
    minWidth: '50%',
  },
  containerStyle: {
    backgroundColor: 'white',
    padding: '60px',
  },
  containerNewStyle: {
    position: 'relative',
    backgroundColor: 'white',
    padding: '60px',
    width: '250mm',
  },
  triangleStyle: {
    content: '',
    position: 'absolute',
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    borderTop: '400px solid #12487e', // Change the color as desired
    borderRight: '900px solid transparent',
  },
  tableStyle: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
  },
  thStyle: {
    backgroundColor: '#f2f2f2',
    padding: '8px',
    textAlign: 'left',
    border: '1px solid #989393ff',
  },
  thStyleRow: {
    backgroundColor: '#f2f2f2',
    padding: '2x',
    textAlign: 'center',
    border: '1px solid #989393ff',
    fontSize: '13px',
  },
  tdStyle: {
    border: '1px solid #dddddd',
    padding: '10px',
  },
  tophstyle: {
    border: '1px solid #dddddd',
    padding: '8px',
    textAlign: 'left',
    minWidth: '50%',
  },
})

export default useInvoiceBillStyles
